import { refUnit } from "@tc/drizzle-v2"
import { eq } from "drizzle-orm"
import {
  SQSClient,
  SendMessageCommand,
  MessageAttributeValue,
} from "@aws-sdk/client-sqs"
import { DbTransaction } from "@tc/middy-decorators"
import { UnitDoc } from "../types/reference-data"
import { searchBuilderLog } from "../utils/logger"

const sqs_client = new SQSClient({})
const queue_url = process.env["UNIT_QUEUE_URL"]

export const getRefUnitData = async (
  tx: DbTransaction,
  id: string,
): Promise<UnitDoc | undefined> => {
  const [row] = await tx
    .select({
      id: refUnit.id,
      listCode: refUnit.listCode,
      unitCode: refUnit.unitCode,
      unitName: refUnit.unitName,
      unitSymbol: refUnit.unitSymbol,
      active: refUnit.active,
      updatedAt: refUnit.updatedAt,
      updatedBy: refUnit.updatedBy,
    })
    .from(refUnit)
    .where(eq(refUnit.id, parseInt(id)))

  if (!row) {
    console.error(`RefUnit with id ${id} not found`)
    return
  }

  const refUnitDoc: UnitDoc = {
    id: row.id.toString(),
    list_code: row.listCode,
    unit_code: row.unitCode,
    unit_name: row.unitName,
    symbol: row.unitSymbol,
    active: row.active,
    updated_at: row.updatedAt.getTime(),
    updated_by: row.updatedBy,
  }

  searchBuilderLog.debug({
    document: refUnitDoc,
  })

  return refUnitDoc
}

export const saveRefUnitToSearch = async (
  tx: DbTransaction,
  id: string,
  collectionName: string,
  options?: { returnDoc?: boolean },
): Promise<void> => {
  const doc = await getRefUnitData(tx, id)

  if (!doc || Object.keys(doc).length === 0) {
    console.error(`Failed to prepare document for id: ${id}`)
    return
  }

  if (options?.returnDoc) return doc as never

  const attributes: Record<string, MessageAttributeValue> = {
    collection: {
      StringValue: collectionName,
      DataType: "String",
    },
  }

  const command = new SendMessageCommand({
    QueueUrl: queue_url,
    MessageBody: JSON.stringify(doc),
    MessageAttributes: attributes,
  })

  await sqs_client.send(command)
}
